import { normalizeTaxIdentifier } from './document';

const keepAlphanumeric = (value) => normalizeTaxIdentifier(value);

export const cpfMask = (value) => (value ? value
  .replace(/\D/g, '')
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d{1,2})/, '$1-$2')
  .replace(/(-\d{2})\d+?$/, '$1') : '');

export const cnpjMask = (value) => {
  const raw = keepAlphanumeric(value);
  if (raw.length !== 14) {
    return value || '';
  }
  return raw.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
};

export const documentMask = (value) => {
  const raw = keepAlphanumeric(value);

  if (raw.length <= 11) {
    return cpfMask(raw);
  }

  return cnpjMask(raw);
};

export const cepMask = (value) => (value ? value
  .replace(/\D/g, '')
  .replace(/(\d{5})(\d{1,2})/, '$1-$2')
  .replace(/(-\d{3})\d+?$/, '$1') : '');

export const dateOfBirthMask = (value) => (value ? value
  .replace(/\D/g, '')
  .replace(/(\d{2})(\d{1,2})/, '$1/$2')
  .replace(/(\d{2})(\d{1,2})/, '$1/$2')
  .replace(/(\/\d{4})\d+?$/, '$1') : '');

export const phoneMask = (value) => (value ? value
  .replace(/\D/g, '')
  .replace(/(\d{2})(\d)/, '($1) $2')
  .replace(/(\d{5}|\d{4})\D*(\d{4})/, '$1-$2')
  .replace(/(-\d{4})\d+?$/, '$1') : '');

export const maskCpfOrCnpj = (value) => documentMask(value);

export const unmaskField = (value) => normalizeTaxIdentifier(value);
